import { render, staticRenderFns } from "./OrdenCompraAceptadas.vue?vue&type=template&id=401cde96&"
import script from "./OrdenCompraAceptadas.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraAceptadas.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraAceptadas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports